import isPast from 'date-fns/isPast';
import isWithinRange from 'date-fns/isWithinInterval';
import isEqual from 'date-fns/isEqual';
import isSameMonth from 'date-fns/isSameMonth';
import subWeeks from 'date-fns/subWeeks';
import closestIndexTo from 'date-fns/closestIndexTo';
import differenceInWeeks from 'date-fns/differenceInWeeks';
import endOfWeek from 'date-fns/endOfWeek';
import startOfWeek from 'date-fns/startOfWeek';
import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
import { formatDate, parse, parseDateTime, DEFAULT_DATEFORMAT } from './format';
export var isDatePast = function isDatePast(date) {
  return isPast(parse(date));
};
export var isDateTimePast = function isDateTimePast(date) {
  return isPast(parseDateTime(date));
};
export var areDatesEqual = function areDatesEqual(a, b) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_DATEFORMAT;
  var formatA = format ? formatDate(a) : a;
  var formatB = format ? formatDate(b) : b;
  return isEqual(parse(formatA), parse(formatB));
};
export var isDateWithinRange = function isDateWithinRange(d, start, end) {
  return start && end && d && (areDatesEqual(d, start, DEFAULT_DATEFORMAT) || areDatesEqual(d, end, DEFAULT_DATEFORMAT) || isWithinRange(parse(d), {
    start: parse(start),
    end: parse(end)
  }));
};
export var isDateTimeWithinRange = function isDateTimeWithinRange(d, start, end) {
  return start && end && d && isWithinRange(parseDateTime(d), {
    start: parseDateTime(start),
    end: parseDateTime(end)
  });
};
export var isDateSameOrBefore = function isDateSameOrBefore(d, comparison) {
  return areDatesEqual(d, comparison, DEFAULT_DATEFORMAT) || isBefore(parse(d), parse(comparison));
};
export var isDateSameOrAfter = function isDateSameOrAfter(d, comparison) {
  return areDatesEqual(d, comparison, DEFAULT_DATEFORMAT) || isAfter(parse(d), parse(comparison));
};
export var isDateBefore = function isDateBefore(d, comparison) {
  return isBefore(parse(d), parse(comparison));
};
export var isDateAfter = function isDateAfter(d, comparison) {
  return isAfter(parse(d), parse(comparison));
};
export var isDateOlderThanAWeek = function isDateOlderThanAWeek(date) {
  return isPast(subWeeks(parse(date), 1));
};
export var hasSameMonth = function hasSameMonth(a, b) {
  return isSameMonth(parse(a), parse(b));
};
export var closestToDateIndex = function closestToDateIndex(date, arr) {
  return closestIndexTo(parse(date), arr.map(function (d) {
    return parse(d);
  }));
};
export var getDifferenceInWeeks = function getDifferenceInWeeks(start, end) {
  return differenceInWeeks(endOfWeek(parse(end)), startOfWeek(parse(start)));
};